import { useState, useContext, useEffect } from "react";
import { Box, Button, Grid, Stack, Typography } from "@mui/material";
//Srcs
import "../../Style/pagestyle.scss";

import { AuthContext } from "../../Context/AuthContext";
import { PageHeaderTitle } from "../../Utils/Component";
import InfoIcon from "@mui/icons-material/Info";
import SchoolIcon from "@mui/icons-material/School";
import TabInfomation from "./Tab/TabInfomation";
import TabEducationLevel from "./Tab/TabEducationLevel";
import { useGetMemberById } from "../../Hooks/useGetMemberById";
import { useNavigate } from "react-router-dom";

const getTabClass = (currentTab, tab) => {
  if (tab === currentTab) return "btn-tab-active";
  return "btn-tab";
};

export default function MemberDetailsForMember() {
  const { t } = useContext(AuthContext);
  const navigate = useNavigate();
  const [tab, setTab] = useState("Infomation");
  const queryParams = new URLSearchParams(window.location.search);
  const id = queryParams.get("id");
  const { data, refetch } = useGetMemberById({ id });

  useEffect(() => {
    refetch();
  }, []);

  return (
    <div className="page-container">
      <Stack direction="row" alignItems="center" spacing={2}>
        <Box className="slash" />

        <Typography
          className={t("class-page-title")}
          onClick={() => navigate("/setting")}
        >
          {t("page_setting")}
        </Typography>

        <Typography className={"slash-title"}>/</Typography>

        <Typography
          className={t("class-page-title")}
          onClick={() => navigate("/setting/member")}
        >
          {t("page_member")}
        </Typography>

        <Typography className={"slash-title"}>/</Typography>

        <Typography className={t("class-page-title")}>
          {data?.lastNameKh + " " + data?.firstNameKh}
        </Typography>
      </Stack>

      <Grid container sx={{ marginTop: 2 }}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Box
            sx={{
              my: 2,
              minWidth: 600,
              borderBottom: 2,
              borderColor: "divider",
            }}
          >
            <Stack direction="row" alignItems="center" sx={{ mb: "-2px" }}>
              <Button
                startIcon={<InfoIcon />}
                onClick={() => setTab("Infomation")}
                className={getTabClass("Infomation", tab)}
              >
                {t("thead_information")}
              </Button>

              <Button
                startIcon={<SchoolIcon />}
                onClick={() => setTab("Education")}
                className={getTabClass("Education", tab)}
              >
                {t("thead_education")}
              </Button>
            </Stack>
          </Box>
        </Grid>

        {["Infomation"].includes(tab) && (
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <TabInfomation />
          </Grid>
        )}

        {["Education"].includes(tab) && (
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <TabEducationLevel />
          </Grid>
        )}
      </Grid>
    </div>
  );
}
